<div class="lib-pegase-date-time-field">
  <mat-form-field class="lib-pegase-date-time-field__date">
    @if (dateLabel()) {
      <mat-label>{{ dateLabel() }}</mat-label>
    }
    <input
      matInput
      [matDatepicker]="datePicker"
      [formControl]="dateControl"
      [required]="required()"
      [readonly]="readonly()"
      [disabled]="disabled()"
      [attr.name]="name() || null"
      [attr.data-tfa]="dataTfa() || null"
      autocomplete="off"
      (dateChange)="onDateChanged()"
      (blur)="onTouched()"
    />
    <mat-datepicker-toggle matSuffix [for]="datePicker" [disabled]=" disabled() ||readonly() || dateControl.disabled" />
    <mat-datepicker #datePicker      [disabled]="disabled()"
    />
    @if (hint()) {
      <mat-hint>{{ hint() }}</mat-hint>
    }
    @if (dateControl.errors?.['required']) {
      <mat-error>{{ requiredErrorLabel() }}</mat-error>
    } @else if (dateControl.errors?.['matDatepickerParse']) {
      <mat-error>{{ parseErrorLabel() }}</mat-error>
    } @else if (dateControl.errors?.['matDatepickerMin']) {
      <mat-error>{{ minErrorLabel() }}</mat-error>
    } @else if (dateControl.errors?.['matDatepickerMax']) {
      <mat-error>{{ maxErrorLabel() }}</mat-error>
    } @else if (customError()) {
      <mat-error>{{ customError() }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="lib-pegase-date-time-field__time">
    @if (timeLabel()) {
      <mat-label>{{ timeLabel() }}</mat-label>
    }
    <input
      matInput
      [matTimepicker]="timePicker"
      [formControl]="timeControl"
      [required]="required()"
      [readonly]="readonly()"
      [disabled]="disabled()"
      [attr.name]="name() ? name() + '-heure' : null"
      [attr.data-tfa]="dataTfa() ? dataTfa() + '-heure' : null"
      autocomplete="off"
      (valueChange)="onTimeChanged()"
      (blur)="onTouched()"
    />
    <mat-timepicker-toggle matSuffix [for]="timePicker" [disabled]="disabled() || readonly() || timeControl.disabled" />
    <mat-timepicker #timePicker [interval]="intervalSeconds()"
    />
    @if (timeControl.errors?.['required']) {
      <mat-error>{{ requiredErrorLabel() }}</mat-error>
    } @else if (timeControl.errors?.['matTimepickerParse']) {
      <mat-error>{{ timeParseErrorLabel() }}</mat-error>
    }
  </mat-form-field>
</div>
